
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/books/[slug]",
      function () {
        return require("private-next-pages/toolkits/books/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/books/[slug]"])
      });
    }
  